module.exports = __webpack_public_path__ + "img/sectores.6dce0e77.png";